import { useState, useCallback } from 'react';

/**
 * useBatchSelection — Hook réutilisable pour la sélection multi-ligne dans les tableaux.
 *
 * Renvoie : { selectedIds, isSelected, toggle, selectAll, clear, count, hasSelection, filterBy }
 */
export function useBatchSelection() {
  const [selectedIds, setSelectedIds] = useState(new Set());

  const toggle = useCallback((id) => {
    setSelectedIds((prev) => {
      const next = new Set(prev);
      if (next.has(id)) next.delete(id); else next.add(id);
      return next;
    });
  }, []);

  const selectAll = useCallback((allItems) => {
    setSelectedIds(new Set((allItems || []).map((it) => it.id)));
  }, []);

  const clear = useCallback(() => setSelectedIds(new Set()), []);

  const isSelected = useCallback((id) => selectedIds.has(id), [selectedIds]);

  const filterBy = useCallback((items, predicate) => {
    return Array.from(selectedIds).filter((id) => {
      const item = items.find((it) => it.id === id);
      return item && (!predicate || predicate(item));
    });
  }, [selectedIds]);

  return {
    selectedIds,
    isSelected,
    toggle,
    selectAll,
    clear,
    count: selectedIds.size,
    hasSelection: selectedIds.size > 0,
    filterBy,
  };
}

export default useBatchSelection;
